import axios from 'axios'
import { getAuthToken } from '@/services/auth'

const getDefaultState = () => {
    return {
        userNotifications: [],
    }
};

const state = getDefaultState();

const getters = {
    getUserNotifications: state => state.userNotifications,
    getReadUserNotifications: state => state.userNotifications.filter((notification) => (notification.hasOwnProperty('IsRead') && notification.IsRead)),
    getUnreadUserNotifications: state => state.userNotifications.filter((notification) => (!notification.hasOwnProperty('IsRead') || !notification.IsRead)),
    getPopupUserNotifications: state => state.userNotifications.filter((notification) => (notification.hasOwnProperty('Type') && (notification.Type === 'Popup' || notification.Type === 'Popup_Quiz_Reminder'))),
    getPopupAnnouncementMessageUserNotifications: state => state.userNotifications.filter((notification) => (notification.hasOwnProperty('Type') && notification.Type === 'Popup_Announcement_Message')),
}

const actions = {

    async fetchUserNotifications({commit, dispatch, state, rootState}) {
        // If offline and we have cached data, return it
        if (!navigator.onLine && state.userNotifications.length > 0) {
            console.log('Offline: Using cached user notifications');
            return state.userNotifications;
        }

        // Try to refresh the token first to ensure we have a valid token
        try {
            await getAuthToken();
        } catch (error) {
            console.error('Failed to refresh token before fetching notifications:', error);
            // Continue anyway and let the API call handle any auth issues
        }

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {
            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {};

            // Add a timestamp to prevent browser/CDN caching
            const timestamp = new Date().getTime();
            config.params = { _t: timestamp };

            const response = await axios.post(`/v2/user-notifications/get`, payloadAPI, config);

            commit('PUSH_USER_NOTIFICATIONS', response.data.userNotificationMessages);
        }
        catch (err) {
            // If offline and fetch failed, return cached data if available
            if (!navigator.onLine && state.userNotifications.length > 0) {
                console.log('Offline: Fetch failed, using cached user notifications');
                return state.userNotifications;
            }
            console.error('Error fetching user notifications:', err);
            dispatch('notifications/addNotification', {
                type: 'error',
                message: 'Failed to fetch user notifications'
            }, {root: true});
        }
    },

    async createUsersNotifications({commit, dispatch, rootState}, payload) {
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {
            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {
                UsersIDs: payload.UsersIDs,
                NotificationContent: payload.NotificationContent
            };

            await axios.post(`/v2/user-notifications/create`, payloadAPI, config);

            dispatch('notifications/addNotification', {
                type: 'success',
                message: 'Notification(s) sent successfully'
            }, {root: true});


            // convert to locale date time
            // const isoString = "2025-05-22T09:57:22.100Z";
            // const localDate = new Date(isoString);
            //
            // // Example: convert to local date-time string
            // // const localDateTimeString = localDate.toLocaleString();
            //
            // const options = {
            //     year: "numeric",
            //     month: "long",
            //     day: "numeric",
            //     hour: "2-digit",
            //     minute: "2-digit",
            //     second: "2-digit",
            //     hour12: false // set to true for AM/PM
            // };
            //
            // const formatted = localDate.toLocaleString(undefined, options);
            //
            // console.log(formatted);

        }
        catch (err) {
            dispatch('notifications/addNotification', {
                type: 'error',
                message: 'Failed to send notification(s)'
            }, {root: true});
        }
    },

    async updateUserNotificationType({commit, dispatch, rootState}, payload) {
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {
            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {
                NotificationID: payload.NotificationID,
                NewNotificationType: payload.NewNotificationType,
                NewNotificationIsRead: payload.NewNotificationIsRead,
            };

            // if (payload.hasOwnProperty('NewNotificationIsRead')) {
            //     payloadAPI.NewNotificationIsRead = payload.NewNotificationIsRead;
            // }

            await axios.post(`/v2/user-notifications/update-type`, payloadAPI, config);

            if (payload.hasOwnProperty('NewNotificationIsRead')) {
                commit('UPDATE_IS_READ', payload);
            }

            // dispatch('notifications/addNotification', {
            //     type: 'success',
            //     message: 'Notification type successfully updated'
            // }, {root: true});


            // convert to locale date time
            // const isoString = "2025-05-22T09:57:22.100Z";
            // const localDate = new Date(isoString);
            //
            // // Example: convert to local date-time string
            // // const localDateTimeString = localDate.toLocaleString();
            //
            // const options = {
            //     year: "numeric",
            //     month: "long",
            //     day: "numeric",
            //     hour: "2-digit",
            //     minute: "2-digit",
            //     second: "2-digit",
            //     hour12: false // set to true for AM/PM
            // };
            //
            // const formatted = localDate.toLocaleString(undefined, options);
            //
            // console.log(formatted);

        }
        catch (err) {
            console.error('Error fetching user notifications:', err);
            dispatch('notifications/addNotification', {
                type: 'error',
                message: 'Failed to update notification type'
            }, {root: true});
        }
    },

    async updateUserNotificationIsRead({commit, dispatch, rootState}, payload) {
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {
            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {
                NotificationID: payload.NotificationID,
                NewNotificationIsRead: payload.NewNotificationIsRead
            };

            await axios.post(`/v2/user-notifications/update-is-read`, payloadAPI, config);

            commit('UPDATE_IS_READ', payload);

            dispatch('notifications/addNotification', {
                type: 'success',
                message: 'Notification marked as read'
            }, {root: true});

        }
        catch (err) {
            dispatch('notifications/addNotification', {
                type: 'error',
                message: 'Failed to mark notification as read'
            }, {root: true});
        }
    },

    async removeUserNotification({commit, dispatch, rootState}, userNotificationID) {
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {
            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            await axios.delete(`/v2/user-notifications/${userNotificationID}`, config);

            commit('DELETE_USER_NOTIFICATION', userNotificationID);

            dispatch('notifications/addNotification', {
                type: 'success',
                message: 'Notification deleted successfully'
            }, {root: true});

        }
        catch (err) {
            dispatch('notifications/addNotification', {
                type: 'error',
                message: 'Failed to delete notification'
            }, {root: true});
        }
    },

    async sendEmails({commit, dispatch, rootState}, payload) {
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {
            let config = {
                headers: {
                    Authorization: rootState.auth.bearer,
                    'Content-Type': 'application/json'
                },
            };

            payload.TemplateData.tenant_title = rootState.tenant.tenantinfo.title;
            payload.TemplateData.tenant_url = rootState.tenant.tenantinfo.fullURL;
            payload.TemplateData.sender_first_name = rootState.auth.userInfo.family_name;
            payload.TemplateData.sender_second_name = rootState.auth.userInfo.given_name;

            let payloadAPI = {
                DestinationEmails: payload.DestinationEmails,
                TemplateData: payload.TemplateData,
            };

            await axios.post(`/v2/email/send-emails`, payloadAPI, config);

            dispatch('notifications/addNotification', {
                type: 'success',
                message: 'Email(s) sent successfully'
            }, {root: true});

        }
        catch (err) {
            dispatch('notifications/addNotification', {
                type: 'error',
                message: 'Failed to send email(s)'
            }, {root: true});
        }
    },

}

const mutations = {
    PUSH_USER_NOTIFICATIONS: (state, userNotifications) => {
        state.userNotifications = userNotifications;
    },

    UPDATE_IS_READ: (state, payload) => {
        const indexUserNotification = state.userNotifications.findIndex((userNotification) => userNotification.ID === payload.NotificationID);

        if (indexUserNotification !== -1) {
            state.userNotifications[indexUserNotification].IsRead = payload.NewNotificationIsRead;
        }
    },

    DELETE_USER_NOTIFICATION: (state, userNotificationID) => {
        state.userNotifications = state.userNotifications.filter((userNotification) => {
            return userNotification.ID !== userNotificationID;
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
